import { useEffect, useState } from "react";
import { Clock } from "lucide-react";
import api from "@/lib/api";

const mxn = (n) => `$${Number(n || 0).toLocaleString("es-MX", { maximumFractionDigits: 0 })}`;

/** Horas pico del mes en la sucursal (ventas hechas en RubiPOS) para reforzar personal. */
export default function HorasPico({ sucursalId }) {
  const [h, setH] = useState(null);
  useEffect(() => {
    const d = new Date(); const loc = (x) => x.toLocaleDateString("sv-SE");
    api.get("/reportes/avanzado", { params: { desde: loc(new Date(d.getFullYear(), d.getMonth(), 1)), hasta: loc(d), sucursal_id: sucursalId || undefined } }).then((r) => setH(r.data.por_hora)).catch(() => setH([]));
  }, [sucursalId]);
  if (!h || !h.some((x) => x.tickets)) return null;
  const max = Math.max(...h.map((x) => x.ventas));
  const top = [...h].filter((x) => x.tickets).sort((a, b) => b.ventas - a.ventas).slice(0, 3).map((x) => x.hora);
  const rango = h.filter((x) => x.tickets);
  const ini = h.indexOf(rango[0]), fin = h.indexOf(rango[rango.length - 1]);
  return (
    <div className="rounded-2xl border border-brand-line bg-white p-3 mt-3" data-testid="horas-pico">
      <div className="flex items-center justify-between mb-2"><div className="eyebrow flex items-center gap-1"><Clock className="w-3.5 h-3.5 text-brand-amber" /> Horas pico del mes</div><div className="text-[11px] text-brand-slate">Refuerza personal a las <b className="text-brand-ink">{top.join(", ")}</b></div></div>
      <div className="flex items-end gap-[3px] h-14">{h.slice(ini, fin + 1).map((x) => <div key={x.hora} title={`${x.hora} · ${mxn(x.ventas)} · ${x.tickets} tickets`} className="flex-1 flex flex-col items-center justify-end gap-0.5" data-testid={`hora-${x.hora}`}><div className={`w-full rounded-t ${top.includes(x.hora) ? "bg-brand-amber" : "bg-brand-ink/15"}`} style={{ height: `${max ? Math.max(4, (x.ventas / max) * 44) : 4}px` }} /><span className="text-[8px] text-brand-muted leading-none">{x.hora.slice(0, 2)}</span></div>)}</div>
    </div>
  );
}
